/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {memo, ReactElement} from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Tooltip, {TooltipTypes} from './Tooltip';

export interface TooltipWrapperProps extends TooltipTypes {
  children: ReactElement<any, any>;
  title: string;
  container: any;
  offset?: Object;
  overflowPadding?: number;
};
  
/**
 * Wraps the tooltip component to keep tooltip popup behavior within the container component
 * 
 * ``` typescript
 *   import {TooltipWrapper} from '@ion/dls/src/components/tooltip/ToolTipWrapper';
 * 
 *   const popupContainer = document.getElementById('base-container');
 *   <TooltipWrapper title='example title'
 *       container={popupContainer}>
 *        <div>
 *         sample tooltip content
 *        </div>
 *   </TooltipWrapper>
 * 
 * ```
 */
export const TooltipWrapper = ({
  children,
  title,
  container,
  offset = {top: 250, left: 250},
  overflowPadding = 8,
  ...props
}: TooltipWrapperProps) => {
  return (
    <VisibilitySensor offset={offset}>
      <Tooltip arrow
        title={title}
        {...props}
        PopperProps={{
          modifiers : {
            preventOverflow : {
              boundariesElement : container,
              enabled           : true,
              padding           : overflowPadding
            }
          }
        }}>
        {children}
      </Tooltip>
    </VisibilitySensor>
  );
};

export default memo(TooltipWrapper);
